export const SEARCH_PREVIEW_PRODUCT = 'search-preview-product';
